import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { UniversalCompetitorCardComponent } from './universal-competitor-card.component';
import { SharedPipesModule } from 'src/app/shared-pipes.module';



@NgModule({
  declarations: [
    UniversalCompetitorCardComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    SharedPipesModule,
  ],
  exports: [
    UniversalCompetitorCardComponent,
  ],
})
export class UniversalComponentCardModule {}
